import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import H2Title from './public/h2Title'
import { BASE_URL, getNewList } from '../api/api'
import { Link, useLocation, useParams } from 'react-router-dom'
import moment from 'moment'
import Pagination from './pagination'
import useMediaQuery from '../hooks/useMediaQuery'
import NavLink from './navLink'

const Hyjj = () => {
  const { channel_id = '', page = 1 } = useParams()
  const pagesize = 20
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const keyword = searchParams.get('keyword')

  console.log(keyword)

  const [data, setData] = useState([])

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}${
        channel_id ? `&channel_id=${channel_id}` : ''
      }&page=${page}&keyword=${keyword}`.replace('.html', '')
    ).then(res => {
      setData(res?.data)
    })
  }, [pagesize, channel_id, page, keyword])

  const isMobile = useMediaQuery()

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0" name={data?.channel?.name}>
        <div className="flex flex-col lg:justify-between lg:flex-row mb-10 lg:mb-0">
          {!data?.list?.data?.length ? <p className="mx-auto text-center">暂无</p> : null}
          <div className="lg:w-[730px]">
            {data?.list?.data.map(
              ({ id, image = '', title, description, publishtime, outlink = '' }, key) => (
                <NavLink
                  to={outlink || `/wzxq/id/${id}`}
                  isOutLink={!!outlink}
                  key={id}
                  className="flex items-center"
                >
                  {image ? (
                    <img
                      style={{ width: 160, height: 116 }}
                      src={`${BASE_URL}${image}`}
                      className="mr-[26px]"
                      alt="123"
                    />
                  ) : null}
                  <div className="w-full">
                    {key ? <hr className="h-[1px] bg-[#D3D3D3] my-7" /> : ''}
                    <p className="text-[#333333] font-alhpr text-[20px] line-clamp-1">{title}</p>
                    <p className="font-sourceHan mt-[22px] line-clamp-3">{description}</p>
                    <p className="text-right font-sourceHan text-sm">
                      {moment(publishtime * 1000).format('YYYY-MM-DD')}
                    </p>
                  </div>
                </NavLink>
              )
            )}
          </div>
          {data?.hot?.length ? (
            <div className="lg:w-[409px] mt-10 lg:mt-0">
              <NavLink to={`/wzxq/id/${data?.hot?.[0]?.id}`}>
                <img
                  style={{ width: isMobile ? '100%' : 409 }}
                  src={`${BASE_URL}${data?.hot?.[0]?.image || ''}`}
                  alt=""
                />
              </NavLink>
              <div className="mt-[46px]">
                <H2Title className="pl-2 border-l-[5px]" title="精彩推荐" />
                <div className="mt-[34px]">
                  {data?.hot?.map(({ title, id }) => (
                    <NavLink
                      key={id}
                      className="block mt-2 flex items-center"
                      to={`/wzxq/id/${id}`}
                    >
                      <p className="bg-[#D3D3D3] w-3 h-3 rounded-full"></p>
                      <p className="ml-2">{title}</p>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
        {data?.list?.data?.length ? (
          <Pagination
            count={data?.list?.total}
            pagesize={pagesize}
            page={data?.list?.current_page}
            totalPage={data?.list?.last_page}
          />
        ) : null}
      </Subpages>
    </Layout>
  )
}

export default Hyjj
